import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {PermissionsTag} from "../../../../shared/interface/permissions-tag";
import {takeUntil} from "rxjs/operators";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";

@Component({
  selector: 'app-permission-tags-details-view',
  templateUrl: './permission-tags-details-view.component.html',
  styleUrls: ['./permission-tags-details-view.component.scss']
})
export class PermissionTagsDetailsViewComponent implements OnInit, OnDestroy {
  @Input() tag: Observable<PermissionsTag>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() terminated = new EventEmitter<any>();

  permissionsTagObject?: PermissionsTag;
  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.tag
      .pipe(takeUntil(this.destroyed$))
      .subscribe((tag: PermissionsTag) => this.permissionsTagObject = tag);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }
}
